export default {
    padding: 15, // white spacing from all sides of graph components from svg boundary
    defaultWidth: 1000, // width of SVG
    defaultHeight: 200, // height of SVG

    lineWidth: 1, // width of lines in 'legend'
    lineColor: '#dfdfdf', // color for lines in 'legend'

    // Bar styles plotted on lagend
    barWidth: 10, // bar width plotted over legend
    barColor: '#2D3E4F', // bar width plotted over legend
    barLabelFont: { fill: '#2D3E4F', fontSize: 20 }, // bar font style plotted over legend
    emptyBarHeight: 0.05,

    // Poiny styles plloted on legend
    pointRadius: 10, // radius of point value
    pointBackgroundColor: '#E3ECF6', // background color (shadow) for point
    pointColor: '#2D3E4F', // color for point
    pointGrayColor: '#9f9f9f', // currently used for showing different colors for diastolic and systolic bars

    // Value Label styles
    labelFont: { fill: '#2D3E4F', fontSize: 20 }, // font style for label
    topLabelOffset: 20, // Offset of label from top
    bottomLabelOffset: 20, // Offset of label from bottom

    // Legend styles
    legendColor: '#cccccc',
    legendHeight: 20,
    legendFont: { fill: '#666666', fontSize: 14 },
    smallLegendFont: { fill: '#666666', fontSize: 10 },
}
